// ============================================
//  icons.js — All SVG Icons for Portfolio
// ============================================

export const IconMail = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <polyline points="2,4 12,13 22,4" />
  </svg>
);

export const IconPhone = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.22 1.18 2 2 0 012.2 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.16 6.16l1.27-.54a2 2 0 012.11.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </svg>
);

export const IconLocation = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
    <circle cx="12" cy="9" r="2.5" />
  </svg>
);

export const IconLinkedIn = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

export const IconGithub = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" />
  </svg>
);

export const IconCode = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
  </svg>
);

export const IconBriefcase = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
    <line x1="12" y1="12" x2="12" y2="12" strokeWidth="3" />
    <path d="M2 12h20" />
  </svg>
);

export const IconGradCap = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
    <path d="M6 12v5c3 3 9 3 12 0v-5" />
  </svg>
);

export const IconStar = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

export const IconArrowRight = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

export const IconCheck = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const IconSun = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5" />
    <line x1="12" y1="1" x2="12" y2="3" />
    <line x1="12" y1="21" x2="12" y2="23" />
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
    <line x1="1" y1="12" x2="3" y2="12" />
    <line x1="21" y1="12" x2="23" y2="12" />
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
  </svg>
);

export const IconMoon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
  </svg>
);

export const IconMenu = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

export const IconClose = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const IconPython = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M11.9 2C9.2 2 7 3.6 7 5.6V8h5v1H4.5C2.6 9 1 10.8 1 13s1.6 4 3.5 4H6v-2.4c0-2.2 2.2-3.6 5-3.6h4c2.2 0 4-1.6 4-3.5V5.6C19 3.6 16.8 2 14.1 2H11.9zM10 5.5a1 1 0 110 2 1 1 0 010-2z" fill="#3776AB"/>
    <path d="M18 9v2.4c0 2.2-2.2 3.6-5 3.6H9c-2.2 0-4 1.6-4 3.5v2.9C5 23.4 7.2 24 9.9 24h2.2c2.7 0 4.9-1.6 4.9-3.6V18h-5v-1h7.5c1.9 0 3.5-1.8 3.5-4s-1.6-4-3.5-4H18zm-4 9.5a1 1 0 110 2 1 1 0 010-2z" fill="#FFD343"/>
  </svg>
);

export const IconDjango = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="#092E20">
    <path d="M11.5 2h2.3v12.8c-1.2.2-2 .3-3 .3-2.8 0-4.3-1.3-4.3-3.7 0-2.3 1.5-3.8 4-3.8.4 0 .7 0 1 .1V2zm0 7.7c-.3-.1-.5-.1-.8-.1-1.2 0-1.9.7-1.9 2s.7 2 1.8 2c.3 0 .6 0 .9-.1V9.7zm5.2-1.9h2.3V17c0 2-.3 3-1 3.8-.7.8-1.7 1.2-3.4 1.2l-.4-1.8c1-.1 1.6-.4 2-.9.3-.5.5-1.3.5-3.3V7.8z"/>
  </svg>
);

export const IconReact = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="2.2" fill="#61DAFB"/>
    <ellipse cx="12" cy="12" rx="10" ry="4" stroke="#61DAFB" strokeWidth="1.2" fill="none"/>
    <ellipse cx="12" cy="12" rx="10" ry="4" stroke="#61DAFB" strokeWidth="1.2" fill="none" transform="rotate(60 12 12)"/>
    <ellipse cx="12" cy="12" rx="10" ry="4" stroke="#61DAFB" strokeWidth="1.2" fill="none" transform="rotate(120 12 12)"/>
  </svg>
);

export const IconMySQL = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M16.5 2C14 2 12 3.1 12 4.5S14 7 16.5 7 21 5.9 21 4.5 19 2 16.5 2z" fill="#00618A"/>
    <path d="M12 4.5V19c0 1.4 2 2.5 4.5 2.5S21 20.4 21 19V4.5" stroke="#00618A" strokeWidth="1.5" fill="none"/>
    <path d="M3 8c0-1.1 1.3-2 3-2s3 .9 3 2-1.3 2-3 2-3-.9-3-2z" fill="#E48E00"/>
    <path d="M3 8v8c0 1.1 1.3 2 3 2s3-.9 3-2V8" stroke="#E48E00" strokeWidth="1.5" fill="none"/>
  </svg>
);

export const IconGit = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="#F05032">
    <path d="M23.1 10.6L13.4.9a2.9 2.9 0 00-4.1 0L7.1 3.1l2.6 2.6a3.5 3.5 0 013.6.9 3.5 3.5 0 01.8 3.5l2.5 2.5a3.5 3.5 0 013.5.8 3.5 3.5 0 010 5 3.5 3.5 0 01-5 0 3.5 3.5 0 01-.7-3.8l-2.3-2.3V18a3.5 3.5 0 01.9 5.7 3.5 3.5 0 01-5 0 3.5 3.5 0 010-5 3.5 3.5 0 011.4-.8v-5.6a3.5 3.5 0 01-1.4-.8 3.5 3.5 0 01-.8-3.6L4.7 5.3.9 9.1a2.9 2.9 0 000 4.1l9.7 9.7a2.9 2.9 0 004.1 0l8.4-8.4a2.9 2.9 0 000-4.1z"/>
  </svg>
);

export const IconVSCode = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M23.1 3L17 .2l-9 8.3L3 4 0 5.5v13L3 20l5-4.5 9 8.3 5.1-2.8V3zM17 17.6l-7-6.4 7-6.2v12.6z" fill="#007ACC"/>
  </svg>
);

export const IconJS = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <rect width="24" height="24" rx="2" fill="#F7DF1E"/>
    <path d="M6.5 17.5c.4.7 1 1.2 2 1.2 1 0 1.6-.5 1.6-1.3 0-.9-.6-1.2-1.7-1.7l-.6-.3C6 14.8 5 14 5 12.2c0-1.6 1.2-2.8 3-2.8 1.3 0 2.2.5 2.9 1.6L9.4 12c-.4-.6-.8-.9-1.4-.9-.6 0-1 .4-1 .9 0 .6.4.9 1.3 1.3l.6.3c2 .9 3 1.6 3 3.5 0 2-1.6 3-3.7 3-2 0-3.3-1-4-2.3L6.5 17.5zM14.5 17.3c.3.5.6.9 1.3.9.6 0 1-.3 1-1.2V9.5h2v7.6c0 2-1.2 2.9-2.9 2.9-1.5 0-2.4-.8-2.9-1.8l1.5-1z" fill="#333"/>
  </svg>
);

export const IconHTML = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path d="M2 2l1.9 21L12 24l8.1-1L22 2H2zm15.6 6H8.4l.2 2.5h10.6l-.7 7.5L12 19.5l-6.5-1.5-.4-4.5h2.4l.2 2.4 4.3 1.2 4.3-1.2.4-4.4H7.8L7.2 8H16.6z" fill="#E34F26"/>
  </svg>
);

export const IconCSS = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path d="M2 2l1.9 21L12 24l8.1-1L22 2H2zm13.6 14.8L12 18l-3.6-1.2-.2-2.8h2.4l.1 1.4 1.3.4 1.3-.4.1-1.8H8.3l-.5-5.6h8.4l-.2 2H10l.1 1.6h5.9l-.4 4.8z" fill="#264DE4"/>
  </svg>
);